<template>
    <b-form :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}" @failure="formFailure"
            :save-params="{api_key: currentUser.api_key, description : JSON.stringify(description)}">

        <div class="col-12">
            <validated-ajax-vue-select :url="blogCategory" name="Category" label="Category" v-model="model.category"
                                       :rules="{required:true}" :disabled="loading"/>
        </div>
        <div class="col-12">
            <validated-input name="Title" label="Title" v-model="model.title"
                             :rules="{required:true}" :disabled="loading"/>
        </div>
        <div class="col-12">
            <validated-textarea label="Title Description" v-model="model.title_description"
                                :rules="{required:true, min : 140, max : 150}" :disabled="loading"/>
        </div>
        <div class="col-12">
            <validated-input
                class=""
                label="Partner Name"
                v-model="model.author_name"
                :rules="{
                    required: true,
                    max: 25
                }"
                :disabled="loading"
            />
        </div>
        <div class="col-12">
            <!-- <file-input class="c-file-input" label="Image" v-model="model.image" :disabled="loading"></file-input> -->

    <label class="field-label">Image</label>

    <div
        class="custom-file-input"
        @click="triggerFileInput(loading)"
    >
        <span>{{ model.image ? model.image.name : 'Browse' }}</span>
    </div>

    <input
        ref="fileInput"
        type="file"
        class="hidden-file-input"
        accept="image/*"
        :disabled="loading"
        @change="handleFileChange($event, model)"
    />
</div>
        <div class="col-12">
            <image-info :width="540" :height="375"/>
        </div>
        <div class="col-12">
            <checkbox-input class="col-6" label="Disable" v-model="model.disabled"
                            :rules="{required:false}" :disabled="loading"/>
        </div>
        <div class="col-12 fl-eqh-r mb-1">
            <div class="btn-group">
                <btn @click="addItem('h')" type="button" size="xs" text="Heading" :disabled="loading"/>
                <btn @click="addItem('d')" type="button" size="xs" text="Description" :disabled="loading"/>
                <btn @click="addItem('b')" type="button" size="xs" text="Bullets" :disabled="loading"/>
                <btn @click="clearAll" type="button" size="xs" text="Clear All" :disabled="loading"/>
            </div>
        </div>
        <div class="col-12">
            <div v-for="(i, index) in description" :key="index">
                <div v-if="i.type==='h'" class="fl-te-c mb-1 mt-3">
                    <label>Heading</label>
                    <btn color="danger" @click="deleteItem(index)" type="button" size="xs"
                         icon="fa fa-trash" :disabled="loading"/>
                </div>
                <validated-input v-if="i.type==='h'" name="Heading" v-model="i.value"
                                 :rules="{required:false}" :disabled="loading" class="mb-1"/>
                <div v-if="i.type==='d'" class="fl-te-c mb-1 mt-3">
                    <label>Description</label>
                    <btn color="danger" @click="deleteItem(index)" type="button" size="xs"
                         icon="fa fa-trash" :disabled="loading"/>
                </div>
                <validated-textarea v-if="i.type==='d'" v-model="i.value"
                                    :rules="{required:false}" :disabled="loading" class="mb-1"/>
                <div v-if="i.type==='b'" class="b-1 round-2 p-1 mt-3">
                    <div class="fl-eqh-r m-1">
                        <div class="btn-group">
                            <btn color="danger" @click="deleteItem(index)" type="button" size="xs"
                                 icon="fa fa-trash" text="Delete All" :disabled="loading"/>
                            <btn @click="addPoint(index)" type="button" size="xs" text="Add Point" :disabled="loading"/>
                        </div>
                    </div>
                    <div class="m-1" v-for="(j, ind) in i.value" :key="ind">
                        <div class="fl-te-c mb-1 mt-3">
                            <label>Point</label>
                            <btn color="danger" @click="deletePoint(index, ind)" type="button" size="xs"
                                 icon="fa fa-trash" :disabled="loading"/>
                        </div>
                        <validated-input name="Point" v-model="j.value"
                                         :rules="{required:false}" :disabled="loading"/>
                    </div>

                </div>
            </div>
        </div>
        <div class="col-12 mt-2">
            <btn class="trn" size="sm" :loading="loading" color="primary" text="Save"
                 loading-text="Saving..." :disabled="loading"/>
        </div>
    </b-form>
</template>

<script>
import urls from '../../../data/urls';
import { mapGetters } from 'vuex';

export default {
    name     : 'AddBLog',
    computed : { ...mapGetters(['currentUser']) },
    data () {
        return {
            blogCategory : urls.admin.blogCategory.vueSelect,
            addUrl       : urls.admin.blog.addEdit,
            description  : []
        };
    },

    methods : {
        addItem (type) {
            if (type === 'b') {
                this.description.push({ id : 'Item', type : type, value : [{ id : 'Point', value : '' }] });
            } else {
                this.description.push({ id : 'Item', type : type, value : '' });
            }
        },
        addPoint (index) {
            this.description[index].value.push({ id : 'Item', value : '' });
        },
        deleteItem (index) {
            this.description.splice(index, 1);
        },
        deletePoint (index, pointIndex) {
            this.description[index].value.splice(pointIndex, 1);
        },
        clearAll () {
            this.description = [];
        },
        formSuccess () {
            this.$notify('Successfully Added Blog..!', 'Success',
                {
                    type : 'success'
                }
            );
            this.$emit('success');
        },
        triggerFileInput (loading) {
            if (!loading) {
                this.$refs.fileInput.click();
            }
        },

        handleFileChange (event, model) {
            const file = event.target.files && event.target.files[0];

            if (!file) {
                return;
            }

            const image = new Image();
            image.onload = () => {
                URL.revokeObjectURL(image.src);
                if (image.width !== 540 || image.height !== 375) {
                    this.$notify(
                        'Please upload an image with dimensions 540 × 375 pixels.',
                        'Invalid Image',
                        {
                            type : 'warning'
                        }
                    );

                    // Clear file input
                    event.target.value = '';

                    // Clear model
                    this.$set(model, 'image', null);

                    return;
                }

                // Valid image
                this.$set(model, 'image', file);
            };
            image.onerror = () => {
                URL.revokeObjectURL(image.src);

                this.$notify(
                    'Unable to read the selected image.',
                    'Invalid Image',
                    {
                        type : 'warning'
                    }
                );

                event.target.value = '';
                this.$set(model, 'image', null);
            };

            image.src = URL.createObjectURL(file);
        },
        formFailure (response) {
            const json = response.data;

            if (json.permission === false) {
                this.$notify(
                    'Invalid Authentication..!',
                    'Permission Denied',
                    {
                        type : 'warning'
                    }
                );
                return;
            }

            if (json.errors) {
                Object.entries(json.errors).forEach(([field, message]) => {
                    this.$notify(
                        `${field}: ${message}`,
                        'Validation Error',
                        {
                            type : 'warning'
                        }
                    );
                });
                return;
            }

            this.$notify(
                'Something went wrong!',
                'Error',
                {
                    type : 'error'
                }
            );
        }
    }
};
</script>

<style scoped>
.hidden-file-input {
  display: none;
}
.custom-file-input {
  width: 100%;
  height: 38px;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 14px;
  line-height: 1.5;
  display: flex;
  align-items: center;
  background-color: white;
  cursor: pointer;
  color:black;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
</style>
